import { Row } from 'antd'
import List from 'app/components/Core/DeliveryItem/List'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import * as React from 'react'

type Props = {
  rental: IRental
  loading?: boolean
}

const Deliveries: React.FC<Props> = ({ rental, loading }) => {
  return (
    <Row>
      <KCol loading={loading} span={24}>
        <List deliveryItems={rental?.deliveries} />
      </KCol>
    </Row>
  )
}

export default Deliveries
